/**
 * Traduit le message d'erreur de la RPC `join_visio_room_by_invite`
 * (`packages/db/migrations/0259_visio_meetings_and_invites.sql`) en texte
 * pour un visiteur (compte réel ou invité anonyme) qui suit un lien
 * d'invitation de salle. Calque `translateRoomError` (`apps/app`).
 */
export function translateInviteError(message: string | null | undefined): string {
  if (!message) return 'Impossible de rejoindre la réunion. Vérifie ta connexion et réessaie.';
  if (message.includes('invalid_invite')) {
    return 'Ce lien d’invitation est invalide ou a été révoqué.';
  }
  if (message.includes('room_ended')) {
    return 'Cette réunion est terminée.';
  }
  if (message.includes('guests_disabled')) {
    return "Cette réunion n'accepte pas les invités sans compte. Demande à l'organisateur un lien avec les invités activés.";
  }
  if (message.includes('room_locked')) {
    return "Cette réunion est verrouillée par l'organisateur : plus personne ne peut entrer.";
  }
  if (message.includes('room_full')) {
    return 'Cette réunion est pleine : le nombre maximum de participants est atteint.';
  }
  if (message.includes('removed_from_room')) {
    return 'Tu as été retiré·e de cette réunion et ne peux pas y revenir.';
  }
  return 'Impossible de rejoindre la réunion. Vérifie ta connexion et réessaie.';
}
